import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

interface Step {
  id: string;
  name: string;
  step_order: number;
}

interface WizardStepperProps {
  steps: Step[];
  currentStep: number;
  completedSteps: Set<number>;
}

export function WizardStepper({ steps, currentStep, completedSteps }: WizardStepperProps) {
  return (
    <nav className="flex items-center gap-2 overflow-x-auto pb-2">
      {steps.map((step, idx) => {
        const isActive = idx === currentStep;
        const isCompleted = completedSteps.has(idx);

        return (
          <div key={step.id} className="flex items-center gap-2">
            {idx > 0 && (
              <div
                className={cn(
                  "h-px w-6 sm:w-10 flex-shrink-0",
                  isCompleted || isActive ? "bg-primary" : "bg-border"
                )}
              />
            )}
            <div className="flex items-center gap-2 flex-shrink-0">
              <div
                className={cn(
                  "h-8 w-8 rounded-full flex items-center justify-center text-xs font-semibold transition-colors",
                  isActive
                    ? "bg-primary text-primary-foreground"
                    : isCompleted
                    ? "bg-primary/10 text-primary border border-primary/30"
                    : "bg-muted text-muted-foreground"
                )}
              >
                {isCompleted ? <Check className="h-4 w-4" /> : idx + 1}
              </div>
              <span
                className={cn(
                  "text-sm hidden sm:block whitespace-nowrap",
                  isActive ? "font-semibold text-foreground" : "text-muted-foreground"
                )}
              >
                {step.name}
              </span>
            </div>
          </div>
        );
      })}
    </nav>
  );
}
